export const BADGE_BASE_TEST_ID = 'badge-base';
